import React, { useCallback, useEffect, useState } from 'react';
import { useEnterpriseManage } from './EnterpriseManageContext';
import StancerKeysForm from '../../components/crm/StancerKeysForm';
import EnterpriseApiKeysPanel from '../../components/enterprise/EnterpriseApiKeysPanel';
import {
  fetchEnterpriseStancerConfiguration,
  updateEnterpriseStancerConfiguration,
} from '../../api/enterprises';

export default function EnterpriseSettingsTab() {
  const { enterpriseId } = useEnterpriseManage();
  const [config, setConfig] = useState(null);
  const [hubupLinked, setHubupLinked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [stancerPublicKey, setStancerPublicKey] = useState('');
  const [stancerPrivateKey, setStancerPrivateKey] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetchEnterpriseStancerConfiguration(enterpriseId);
      setConfig(res?.data?.configuration ?? null);
      setHubupLinked(res?.data?.hubupLinked === true);
    } catch (e) {
      setError(e?.message || 'Impossible de charger les paramètres.');
      setConfig(null);
    } finally {
      setLoading(false);
    }
  }, [enterpriseId]);

  useEffect(() => {
    void load();
    setStancerPublicKey('');
    setStancerPrivateKey('');
  }, [load]);

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const payload = {};
      if (stancerPublicKey.trim()) payload.stancerPublicKey = stancerPublicKey.trim();
      if (stancerPrivateKey.trim()) payload.stancerPrivateKey = stancerPrivateKey.trim();
      if (!payload.stancerPublicKey && !payload.stancerPrivateKey) {
        setError('Saisissez au moins une clé à enregistrer.');
        setSaving(false);
        return;
      }
      const res = await updateEnterpriseStancerConfiguration(enterpriseId, payload);
      setConfig(res?.data?.configuration ?? null);
      setStancerPublicKey('');
      setStancerPrivateKey('');
      setSuccess('Clés enregistrées.');
      setTimeout(() => setSuccess(''), 4000);
    } catch (e) {
      setError(e?.message || 'Enregistrement impossible.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4 max-w-lg">
      <h1 className="text-lg font-semibold text-foreground">Paramètres</h1>

      {error ? <p className="text-sm text-destructive">{error}</p> : null}
      {success ? <p className="text-sm text-emerald-600">{success}</p> : null}

      {loading ? (
        <p className="text-sm text-muted-foreground">Chargement…</p>
      ) : (
        <>
        <EnterpriseApiKeysPanel enterpriseId={enterpriseId} />
        <section className="rounded-lg border border-border p-4">
          <h2 className="text-sm font-medium text-foreground mb-3">Paiements (Stancer)</h2>
          {hubupLinked ? (
            <p className="text-xs text-muted-foreground mb-3">Synchronisé avec HubUP si configuré.</p>
          ) : null}
          <StancerKeysForm
            publicKey={stancerPublicKey}
            privateKey={stancerPrivateKey}
            onPublicKeyChange={setStancerPublicKey}
            onPrivateKeyChange={setStancerPrivateKey}
            publicConfigured={config?.stancerPublicKeyConfigured}
            privateConfigured={config?.stancerPrivateKeyConfigured}
            keysConfigured={config?.stancerKeysConfigured}
            saving={saving}
            onSubmit={handleSave}
          />
        </section>
        </>
      )}
    </div>
  );
}
